import React, { useState, useRef, useEffect } from "react";
import { Box, MenuItem, SelectChangeEvent } from "@mui/material";
import { Divider } from "@mui/material";
import images from "../../../../Assets/images";
import VcDatePicker from "Components/UI/DatePicker/DatePicker";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { scrollBar } from "Components/Common/Header/ManageOutsideClickClose";
import "../../../../Assets/css/date-picker.css";
import { useApiCall } from "Hooks/useApiCall";
import { getLocalStorage } from "Network/ApiService";
import { ls_vars } from "Library/Constants";
import { set } from "date-fns";
import ButtonElement from "../../../UI/Button";
import "./style.css";
import ReactPaginate from "react-paginate";
import { pageOptions } from "StaticData/UserManageMent/status";
import Pagination from "Components/UI/Pagination/Pagination";
import { Padding } from "@mui/icons-material";
import Table from "../SummaryEmissionsreport/Table";
import {
  downloadOffRoadReports,
  getSummaryReports,
} from "Network/Core/EquipmentMaster/equipment";
import { formatDate } from "Library/Utils";

const METRIC_TON_CONVERSION = 0.907;

const SummaryEmissionsReport: React.FC = () => {
  const { t } = useTranslation();
  const { call } = useApiCall();
  const project = getLocalStorage(ls_vars.PROJECT_DATA);
  const region = getLocalStorage(ls_vars.REGION_ID);
  const user = getLocalStorage(ls_vars.USER_DATA);
  const inputRefS = useRef<HTMLDivElement>(null);
  const inputRefE = useRef<HTMLDivElement>(null);
  const [orderBy, setOrderBy] = useState<string>("id");
  const [statusIsASC, setStatusIsASC] = useState<boolean>(true);
  const [isScrolling, setIsScrolling] = useState<boolean>(false);


  const [pageCount, setPageCount] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(10);
  const [startDate, setStartDate] = useState<any>("");
  const [endDate, setEndDate] = useState<any>("");
  const [companyOptions, setCompanyOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [contactNamesOptions, setContactNamesOptions] = useState<
    { label: string; value: string }[]
  >([]);
  // Add new state variables for filtered data and selected values
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [reportData, setReportData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [shortCo2FootPrint, setShortCo2FootPrint] = useState<number>(0.0);
  const [totalCo2EmissionPercentage, setTotalCo2EmissionPercentage] =
    useState<number>(0.0);



  scrollBar(setIsScrolling);
  const toggleSort = (field: string, isAcs: boolean) => {
    if (field !== "id") {
      setStatusIsASC(!isAcs);
      setOrderBy(isAcs ? field : "-" + field);
    }
  };

  const handlePageClick = (data: { selected: number }) => {
    const { selected } = data;
    setPage(selected + 1);
  };

  const onChangePage = (e: { value: number }) => {
    setPerPage(e.value);
  };

  const handleDateChange = (date: Date | null, type: "start" | "end") => {
    if (type === "start") {
      setStartDate(date);
    } else {
      setEndDate(date);
    }
  };

  useEffect(() => {
    const fetchEquipmentUsageReport = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const formattedStartDate = startDate
          ? moment(startDate).format("YYYY-MM-DD")
          : "";
        const formattedEndDate = endDate
          ? moment(endDate).format("YYYY-MM-DD")
          : "";

        call(
          () =>
            getSummaryReports(
              {
                startDate: formattedStartDate,
                endDate: formattedEndDate,

              },
              region,
              project.ref
            ),
          (response: any) => {
            const data = response?.results || response || [];
            setReportData(data);
            calculateTotals(data);
          }
        );
      } catch (err) {
        setError("Failed to fetch equipment usage report");
        console.error("Error fetching equipment usage report:", err);
      } finally {
        setIsLoading(false);
      }
    };

    if (startDate && endDate && region) {
      fetchEquipmentUsageReport();
    }
  }, [startDate, endDate, region]);

  const roundToTwoDecimals = (num: number): number => {
    return Number(Math.round(num * 100) / 100);
  };

  const calculateTotals = (data: any[]) => {
    let totalFootprint = 0;
    let totalTotalFootprint = 0;
    let totalCo2EmissionSum = 0;
    let count = 0;
    let reportCount = data.length;

    data.forEach((item) => {
      item.data.forEach((entry: any) => {
        totalFootprint = roundToTwoDecimals(
          totalFootprint + parseFloat(entry.footprint)
        );
        totalTotalFootprint = roundToTwoDecimals(
          totalTotalFootprint + parseFloat(entry.totalfootprint)
        );

        const co2Value = parseFloat(entry.totalco2emission.replace("%", ""));
        totalCo2EmissionSum = roundToTwoDecimals(
          totalCo2EmissionSum + co2Value
        );
        count++;
      });
    });

    const averageCo2Emission =
      count > 0 ? roundToTwoDecimals(totalCo2EmissionSum / reportCount) : 0;

    setShortCo2FootPrint(totalFootprint);
    setTotalCo2EmissionPercentage(averageCo2Emission);
  };

  const exportReportData = async (reportType: string) => {
    const formattedStartDate = startDate
      ? moment(startDate).format("YYYY-MM-DD")
      : "";
    const formattedEndDate = endDate
      ? moment(endDate).format("YYYY-MM-DD")
      : "";

    call(
      () =>
        downloadOffRoadReports(
          {
            startDate: formattedStartDate,
            endDate: formattedEndDate,
            reportType: reportType,
          },
          region,
          project.ref
        ),
      (response: any) => { }
    );
  };

  useEffect(() => {
    let today = new Date();
    let endDate = new Date();
    // Get one month after date
    endDate.setMonth(today.getMonth() + 1);
    endDate.setHours(0, 0, 0, 0);

    setStartDate(formatDate(today));
    setEndDate(formatDate(endDate));
  }, []);

  return (
    <div className="page-wrapper">
      <div className="page-header">
        <h3 className="page-title">
          {t("Translation.summary_emissions_report")}
        </h3>
      </div>
      <div className="page-content custom-list-div ">
        <table
          style={{
            width: "100%",
            padding: "20px 24px",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr>
              <th
                className="lable"
                style={{
                  textAlign: "left",
                  padding: "12px",
                  borderBottom: "1px solid #e0e0e0",
                }}
              >
                {t("Translation.project")}
              </th>
              {/* <th
                className="lable"
                style={{
                  textAlign: "left",
                  padding: "12px",
                  borderBottom: "1px solid #e0e0e0",
                }}
              >
                Client
              </th> */}
              <th
                className="lable"
                style={{
                  textAlign: "left",
                  padding: "12px",
                  borderBottom: "1px solid #e0e0e0",
                }}
              >
                {t("Translation.location")}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ padding: "12px" }}>{project.name}</td>
              {/* <td style={{ padding: "12px" }}>Client 1</td> */}
              <td style={{ padding: "12px" }}>{user.city}</td>
            </tr>
          </tbody>
        </table>
        <Divider />

        <div className="booking-list-form">
          <Box
            sx={{
              padding: "0 24px 22px 24px",
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            {/* Single row with date filters, search, and download button */}
            <Box
              sx={{
                display: "flex",
                gap: "16px",
                flexWrap: "wrap",
                alignItems: "center",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              {/* Left side with date pickers */}
              <Box sx={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                flexWrap: "nowrap",
                flex: "0 1 auto",
              }}>
                <Box className="date-box-frontend">
                  <VcDatePicker
                    date={startDate}
                    onDateChange={(val: Date | null) =>
                      handleDateChange(val, "start")
                    }
                  />
                </Box>
                <Box className="to" sx={{ marginBottom: 0 }}>
                  {t("Translation.to")}
                </Box>
                <Box className="date-box-frontend">
                  <VcDatePicker
                    date={endDate}
                    onDateChange={(val) => handleDateChange(val, "end")}
                    minDate={new Date(startDate || new Date())}
                  />
                </Box>
              </Box>



              {/* Right side - download button */}
              <Box sx={{
                display: "flex",
                justifyContent: "flex-end",
                flex: "0 0 auto",
              }}>
                <ButtonElement
                  buttonLabel={<img src={images.download} alt="Download" />}
                  handleClick={() => exportReportData("sm")}
                  className="btn white-btn dl-btn"
                />
              </Box>
            </Box>
          </Box>
        </div>

        <Divider />
        <div
          style={{
            height: "35%",
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row",
            padding: "20px 24px 0px 24px",
          }}
        >
          <div className="metric-box box" style={{ backgroundColor: "#EAF9DE" }}>
            <h2 style={{ textAlign: "center", color: "#085E50" }}>
              {shortCo2FootPrint}
            </h2>
            <h6 style={{ textAlign: "center", color: "#085E50" }}>
              {t("Translation.CO2 Footprint (short tons)")}
            </h6>
          </div>
          <div className="metric-box box" style={{ backgroundColor: "#E3F1FF" }}>
            <h2 style={{ textAlign: "center", color: " #004996" }}>
              {shortCo2FootPrint * METRIC_TON_CONVERSION}
            </h2>
            <h6 style={{ textAlign: "center", color: "#004996" }}>
              {t("Translation.Total CO2 Footprint (metric tons)")}
            </h6>
          </div>
          <div className="metric-box box" style={{ backgroundColor: "#EFF3F6" }}>
            <h2 style={{ textAlign: "center", color: " #3F4B57" }}>
              {totalCo2EmissionPercentage}%
            </h2>
            <h6 style={{ textAlign: "center", color: "#3F4B57" }}>
              {t("Translation.of Total CO2 Emissions")}
            </h6>
          </div>
        </div>
        {Array.isArray(reportData) && reportData.map((supplier, index) => (
          <Table
            key={index}
            title={`${supplier.subActivity} - ${supplier.supplierCompany}`} // Dynamic title
            data={supplier.data} // Data for this supplier
          />
        ))}
      </div>
    </div>
  );
};

export default SummaryEmissionsReport;
const styles = {
  headerStyle: {
    backgroundColor: "#EFF3F6",
    color: "#5A5A5A",
  },
  filterContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
    gap: "14px",
  },
  selectStyle: {
    width: "100%",
    height: "48px",
    background: "#EFF3F6",
    color: "#A0AEBD",
    border: "none",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
  },
  dateRangeContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: "14px",
  },
  datePickerWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  lastColumnWrapper: {
    display: "flex",
    justifyContent: "flex-end", // or 'flex-end' if you only want the button
    alignItems: "center",
  },
  downloadBtn: {
    border: "1px solid rgb(216 217 218)",
    borderRadius: "8px",
    cursor: "pointer",
  },
  dateRangeSeparator: {
    marginLeft: "10px",
    marginRight: "10px",
  },
  dateBoxContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
  },
  searchImage: {
    // top: "14px" as "14px",
    position: "relative" as "relative",
    height: "20px",
    width: "20px",
    left: "30px" as "30px",
  },
  searchBox: {
    height: "45px" as "45px",
    width: "70%" as "70%",
    paddingLeft: "25px" as "25px",
    background: "#EFF3F6" as "#EEF3F6",
    border: "none" as "none",
  },
  tableHeader: {
    backgroundColor: "#EFF3F6",
    color: "#5A5A5A",
    "& th": {
      padding: "12px",
    },
  },
  tableRow: {
    "& td": {
      padding: "12px",
    },
  },
};
